import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import AuthServices from "../../services/AuthServices";
import Swal from "sweetalert2";

function NewMessagePopup({ show, onClose }) {

 const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleSend = async () => {
    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }

    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>New Message</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Control type="email" placeholder="From" value={formData.email} name = "email" onChange={handleChange}/>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control type="email" value="Edu@AngelWatch.org" />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control type="text" placeholder="Name" name="name" value={formData.name} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control as="textarea" rows={6} placeholder="Type your message..." name="message" value={formData.message} onChange={handleChange}/>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="primary" onClick={handleSend}>Send</Button>
      </Modal.Footer>
    </Modal>
  );
}

NewMessagePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function MessageToggle({ showMessage, handleClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(showMessage);
  }, [showMessage]);

  const handleClosePopup = () => {
    setVisible(false);
    handleClose();
  };

  return (
    <div>
      <NewMessagePopup show={visible} onClose={handleClosePopup} />
    </div>
  );
}

MessageToggle.propTypes = {
  showMessage: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
